import { Component, OnInit } from '@angular/core';
import {LoadingService} from "../../../modules/shared/services/loading.service";
import {HttpClient} from "@angular/common/http";
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.scss']
})
export class LeadFormComponent implements OnInit {

  submitted = false;
  form: FormGroup;
  formSent = false;

  constructor(
      private loadingService: LoadingService,
      private http: HttpClient
  ) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      partnerTaxId: new FormControl(null, Validators.required),
      restaurantName: new FormControl(null, Validators.required),
      name: new FormControl(null, Validators.required),
      taxId: new FormControl(null, Validators.required),
      phone: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      comment: new FormControl(null, Validators.required),
    })
  }

  save() {
    this.submitted = true;
    if (!this.form.valid) {
      return;
    }

    this.formSent = true;
    this.http.post('https://hook.eu2.make.com/gspw3vy2o5ha22qc3283zfxg564bd2u4', this.form.value).subscribe()
  }
}
